import React, { createContext, useContext } from 'react'
import { store, type Store } from '@store/Store'

const StoreContext = createContext<Store>(store)

export const StoreProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>
}

export const useStore = () => useContext(StoreContext)
